import { render, staticRenderFns } from "./SchoolStateStep.vue?vue&type=template&id=4e007442&scoped=true&"
import script from "./SchoolStateStep.vue?vue&type=script&lang=js&"
export * from "./SchoolStateStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e007442",
  null
  
)

export default component.exports